import classNames from 'classnames';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PromotionDiscount } from '../../../utils/checkoutState';
import { getAssetUrl } from '../../../utils/config';
import Collapse from '../../atoms/Collapse';
import EllipsisText from '../../atoms/EllipsisText';
import Price from '../../atoms/Price';

const BLOCK_CLASS = 'price-summary__section--promotion';

const PromotionDiscounts = ({ promotions }: { promotions: PromotionDiscount[] }) => (
  <div className={`${BLOCK_CLASS}__list`}>
    {promotions.map(({ id, name, discount }) => (
      <div className={`${BLOCK_CLASS}__item`} key={id}>
        <img src={getAssetUrl('discount/discount.svg')} />
        <EllipsisText className={`${BLOCK_CLASS}__name`}>
          {name ?? <FormattedMessage id="payment.promotion.fallbackCodeName" />}
        </EllipsisText>
        <Price className={`${BLOCK_CLASS}__amount`} price={discount * -1} />
      </div>
    ))}
  </div>
);

type PromotionSectionProps = {
  total: number;
  promotions: PromotionDiscount[];
  isCollapsible: boolean;
};

const PromotionSection = ({ total, promotions, isCollapsible }: PromotionSectionProps) => {
  const [isOpen, setOpen] = useState(false);
  const promotionDiscounts = <PromotionDiscounts promotions={promotions} />;

  return (
    <dl className={classNames('price-summary__section', BLOCK_CLASS)}>
      <dt
        className={classNames(`${BLOCK_CLASS}__headline`, { [`${BLOCK_CLASS}__headline--collapsible`]: isCollapsible })}
        onClick={() => setOpen(!isOpen)}
      >
        <EllipsisText className="price-summary__section__name">
          <FormattedMessage id="basket.yourCouponSavings" />
        </EllipsisText>
        {isCollapsible && <img src={getAssetUrl(`inputs/chevron${isOpen ? 'Up' : 'Down'}.svg`)} />}
        <Price price={total * -1} className={`${BLOCK_CLASS}__total`} />
      </dt>
      {isCollapsible ?
        <Collapse isOpen={isOpen} onClose={() => setOpen(false)}>
          {promotionDiscounts}
        </Collapse>
      : promotionDiscounts}
    </dl>
  );
};

export default PromotionSection;
